import { useNavigate } from "react-router-dom"
import { ToastContainer } from "react-toastify"
import TextField from "../../components/UI/TextField"
import { useForm } from "react-hook-form";
import { getalldrones } from "../../api/dronesAPI";
import { useAuthStore } from "../../store/authStore";
import { useEffect, useState } from "react";
import { useMutation, useQuery } from "@tanstack/react-query";
import TextArea from "../../components/UI/TextArea";
import { issuesArray } from "../../helpers/constants";
import { useMapStore } from "../../store/mapStore";
import { Check } from "react-feather";
import { addIssue } from "../../api/issuesApi";

const ReportIssue = () => {
    const navigate = useNavigate();
    const { token } = useAuthStore((state) => state)
    const [allDrones, setAllDrones] = useState([])
    const { toast, setLoaderState } = useAuthStore((state) => state)
    const {
        register,
        handleSubmit,
        getValues,
        watch,
        reset,
        formState: { errors },
    } = useForm();

    const { isLoading, data, error } = useQuery({
        queryFn: getalldrones,
        queryKey: ["getDrones", token, "approved"],
        refetchOnWindowFocus: false,
    });

    const IssueQuery = useMutation({
        mutationFn: addIssue,
    });

    useEffect(() => {
        if (IssueQuery.isLoading || isLoading) {
            setLoaderState(true)
        } else {
            setLoaderState(false)
        }
    }, [IssueQuery.isLoading, isLoading])

    useEffect(() => {
        if (IssueQuery?.data?.data) {
            toast("success", IssueQuery.data.data.message)
        }
    }, [IssueQuery.isSuccess])

    const submitIssue = () => {
        let payload = getValues();
        const incidentDiscoverTime = new Date(`${payload.incidentDiscoverTime}:00`).getTime()
        const droneRecoverTime = new Date(`${payload.droneRecoverTime}:00`).getTime()
        payload = { ...payload, incidentDiscoverTime: incidentDiscoverTime, droneRecoverTime: droneRecoverTime };
        IssueQuery.mutate({ token, payload });
        reset();
    };

    useEffect(() => {
        if (data?.data?.data) {
            setAllDrones(data.data.data)
        }
    }, [data])

    const issueVal = watch("issue")
    const incidentDiscoverTimeValidation = (value) => {
        const curDate = new Date().getTime();
        const selectedDate = new Date(value).getTime();
        if (selectedDate > curDate) {
            toast("error", "Keep the Incident Date within the Recover date")
            return false;
        }
    };

    const droneRecoverTimeValidation = (value) => {
        const incidentTime = watch("incidentDiscoverTime")
        const curDate = new Date(incidentTime).getTime();
        const presentDate = new Date().getTime();
        const selectedDate = new Date(value).getTime();
        if (selectedDate < curDate) {
            toast("error", "Keep the Incident Date within the Recover date")
            return false;
        }
        if (selectedDate > presentDate) {
            toast("error", "Keep the Recover Date within the current date")
            return false;
        }
    }
    return (
        <>
            <div className="p-4">
                <ToastContainer />
                <div className="flex justify-between items-center">
                    <h1 className="text-4xl w-full h-full">Report a issue</h1>
                    <div className="flex">
                        <button
                            onClick={handleSubmit(submitIssue)}
                            className="bg-tblu flex text-white whitespace-nowrap p-4 text-md rounded-xl mr-3"
                        >
                            <Check /> &ensp; Save
                        </button>
                        <button
                            onClick={() => navigate("/layout/issues")}
                            className="bg-tblu flex text-white whitespace-nowrap p-4 text-md rounded-xl"
                        >
                            View Issues
                        </button>
                    </div>
                </div>
                <br />
                <hr />

                <form
                    // onSubmit={handleSubmit(submitDrone)}
                    className="grid grid-cols-2 gap-2 mt-10"
                >
                    <span>
                        <h2 className="text-tblu">Select Drone*</h2>
                        <select
                            {...register("droneId", { required: true })}
                            className="w-full my-2 block p-4 border-slate-200 border rounded-xl focus:outline-none cursor-pointer"
                        >
                            {allDrones.map((drone, index) => (
                                <option key={index} value={drone.droneId}>
                                    {drone.droneName}
                                </option>
                            ))}
                        </select>
                    </span>
                    <span>
                        <h2 className="text-tblu">Select Issue*</h2>
                        <select
                            {...register("issue", { required: true })}
                            className="w-full my-2 block p-4 border-slate-200 border rounded-xl focus:outline-none cursor-pointer"
                        >
                            {issuesArray.map((issue, index) => (
                                <option key={index} value={issue}>
                                    {issue}
                                </option>
                            ))}
                        </select>
                    </span>
                    <TextField
                        inputProps={{ ...register("incidentDiscoverTime", { required: true, validate: incidentDiscoverTimeValidation }) }}
                        label="Incident Discover Time*"
                        type="datetime-local"
                    />
                    <TextField
                        inputProps={{ ...register("droneRecoverTime", { required: true, validate: droneRecoverTimeValidation }) }}
                        label="Drone Recover Time*"
                        type="datetime-local"
                    />
                    <TextArea
                        inputProps={{ ...register("issueDescription", { required: (issueVal === "other") }) }}
                        label={`Issue Description ${issueVal === "other" ? "(Required)" : "(Optional)"}`}
                    />
                </form>
            </div>
        </>
    )
}

export default ReportIssue